import { Injectable } from '@angular/core';
import {
    LanguageAvailabilityByProduct,
    GlobalEmailTypes
} from '../../constants-types/Enums';
import { Language } from '../../shared/Language.model';
import { ILanguagesApi } from './LanguagesApi.connectinterface';

@Injectable({ providedIn: 'root' })
export class LanguagesApiMock implements ILanguagesApi {
    getFullSiteLanguages(): Promise<Language[]> {
        throw new Error('Method not implemented.');
    }

    getEmailSubjectMessageOverrides(
        _keysToTranslate: string[],
        _languageCode: string,
        _companyId: string,
        _emailType: GlobalEmailTypes
    ): Promise<any[]> {
        throw new Error('Method not implemented.');
    }

    fillInKeys(
        _keysToTranslate: string[],
        _languageCode: string
    ): Promise<any[]> {
        throw new Error('Method not implemented.');
    }

    getLanguages(
        _product: LanguageAvailabilityByProduct,
        _languageCode?: string
    ) {
        return new Promise<Language[]>(() => []);
    }

    behavioralLanguages = [
        {
            display: 'Afrikaans - Afrikaans',
            locale: 'af-ZA'
        },
        {
            display: 'Albanian - Shqip',
            locale: 'sq-AL'
        },
        {
            display: 'Arabic (International) - العربية',
            locale: 'ar-XM'
        },
        {
            display: 'Armenian - հայերեն',
            locale: 'hy-AM'
        },
        {
            display: 'Basque - Euskara',
            locale: 'eu-ES'
        },
        {
            display: 'Bulgarian - Български',
            locale: 'bg-BG'
        },
        {
            display: 'Catalan - Català',
            locale: 'ca-ES'
        },
        {
            display: 'Chinese (Simplified) - 简体中文',
            locale: 'zh-CN'
        },
        {
            display: 'Chinese (Traditional) - 繁體中文',
            locale: 'zh-TW'
        },
        {
            display: 'Croatian - Hrvatski',
            locale: 'hr-HR'
        },
        {
            display: 'Czech - Ceština',
            locale: 'cs-CZ'
        },
        {
            display: 'Danish - Dansk',
            locale: 'da-DK'
        },
        {
            display: 'Dutch - Nederlands',
            locale: 'nl-NL'
        },
        {
            display: 'English',
            locale: 'en-US'
        },
        {
            display: 'Estonian - Eesti Keel',
            locale: 'et-EE'
        },
        {
            display: 'Farsi - فارسی',
            locale: 'fa-IR'
        },
        {
            display: 'Filipino - Tagalog',
            locale: 'fil-PH'
        },
        {
            display: 'Finnish - Suomi',
            locale: 'fi-FI'
        },
        {
            display: 'French - Français',
            locale: 'fr-FR'
        },
        {
            display: 'Georgian - ქართული',
            locale: 'ka-GE'
        },
        {
            display: 'German - Deutsch',
            locale: 'de-DE'
        },
        {
            display: 'Greek - Ελληνικά',
            locale: 'el-GR'
        },
        {
            display: 'Guajarati - ગુજરાતી',
            locale: 'gu-IN'
        },
        {
            display: 'Haitian Creole - Kreyòl Ayisyen',
            locale: 'ht-HT'
        },
        {
            display: 'Hebrew - עברית',
            locale: 'he-IL'
        },
        {
            display: 'Hindi - हिंदी',
            locale: 'hi-IN'
        },
        {
            display: 'Hungarian - Magyar',
            locale: 'hu-HU'
        },
        {
            display: 'Icelandic - Íslenska',
            locale: 'is-IS'
        },
        {
            display: 'Ilocano - Ilokano',
            locale: 'ilo-PH'
        },
        {
            display: 'Indonesian - Bahasa Indonesia',
            locale: 'id-ID'
        },
        {
            display: 'Italian - Italiano',
            locale: 'it-IT'
        },
        {
            display: 'Japanese - 日本語',
            locale: 'ja-JP'
        },
        {
            display: 'Kazakh - Қазақ тілі',
            locale: 'kk-KZ'
        },
        {
            display: 'Khmer - ភាសាខ្មែរ',
            locale: 'km-KH'
        },
        {
            display: 'Korean - 한국어',
            locale: 'ko-KR'
        },
        {
            display: 'Lao - ພາສາລາວ',
            locale: 'lo-LA'
        },
        {
            display: 'Latvian - Latviešu',
            locale: 'lv-LV'
        },
        {
            display: 'Lithuanian - Lietuvių k',
            locale: 'lt-LT'
        },
        {
            display: 'Macedonian - Македонски',
            locale: 'mk-MK'
        },
        {
            display: 'Malay - Bahasa Melayu',
            locale: 'ms-MY'
        },
        {
            display: 'Malayalam - മലയാളം',
            locale: 'ml-IN'
        },
        {
            display: 'Norwegian (Bokmål) - Norsk',
            locale: 'nb-NO'
        },
        {
            display: 'Papiamentu - Papiamentu',
            locale: 'pap-AW'
        },
        {
            display: 'Polish - Polski',
            locale: 'pl-PL'
        },
        {
            display: 'Portuguese - Português',
            locale: 'pt-PT'
        },
        {
            display: 'Portuguese (Brazil) - Português (Brasil)',
            locale: 'pt-BR'
        },
        {
            display: 'Punjabi - ਪੰਜਾਬੀ',
            locale: 'pa-IN'
        },
        {
            display: 'Romanian - Română',
            locale: 'ro-RO'
        },
        {
            display: 'Russian - Русский',
            locale: 'ru-RU'
        },
        {
            display: 'Samoan - Samoan',
            locale: 'sm-WS'
        },
        {
            display: 'Serbian (Latin) - Srpski (Latinica)',
            locale: 'sr-Cyrl-CS'
        },
        {
            display: 'Sesotho - Sesotho',
            locale: 'st-LS'
        },
        {
            display: 'Sinhalese - සිංහල',
            locale: 'si-LK'
        },
        {
            display: 'Slovak - Slovenčina',
            locale: 'sk-SK'
        },
        {
            display: 'Slovenian - Slovensko',
            locale: 'sl-SI'
        },
        {
            display: 'Spanish (Latin America) - Español (Latinoamérica)',
            locale: 'es-XL'
        },
        {
            display: 'Spanish (Modern Sort) - Español (Europeo)',
            locale: 'es-ES'
        },
        {
            display: 'Swahili - Swahili',
            locale: 'sw-KE'
        },
        {
            display: 'Swedish - Svenska',
            locale: 'sv-SE'
        },
        {
            display: 'Tamil - தமிழ்',
            locale: 'ta-IN'
        },
        {
            display: 'Thai - ไทย',
            locale: 'th-TH'
        },
        {
            display: 'Tongan - Lea Faka-Tonga',
            locale: 'to-TO'
        },
        {
            display: 'Turkish - Türkçe',
            locale: 'tr-TR'
        },
        {
            display: 'Ukrainian - Українська',
            locale: 'uk-UA'
        },
        {
            display: 'Vietnamese - Tiếng Việt',
            locale: 'vi-VN'
        },
        {
            display: 'Xhosa - IsiXhosa',
            locale: 'xh-ZA'
        },
        {
            display: 'Zulu - IsiZulu',
            locale: 'zu-ZA'
        }
    ];
    cognitiveLanguages = [
        {
            display: 'Afrikaans - Afrikaans',
            locale: 'af-ZA'
        },
        {
            display: 'Albanian - Shqip',
            locale: 'sq-AL'
        },
        {
            display: 'Arabic (Gulf) - لعربية',
            locale: 'ar-AE'
        },
        {
            display: 'Arabic (International) - العربية',
            locale: 'ar-XM'
        },
        {
            display: 'Armenian - հայերեն',
            locale: 'hy-AM'
        },
        {
            display: 'Azerbaijani - azərbaycan dili',
            locale: 'Lt-az-AZ'
        },
        {
            display: 'Basque - Euskara',
            locale: 'eu-ES'
        },
        {
            display: 'Bulgarian - Български',
            locale: 'bg-BG'
        },
        {
            display: 'Catalan - Català',
            locale: 'ca-ES'
        },
        {
            display: 'Chinese (Simplified) - 简体中文',
            locale: 'zh-CN'
        },
        {
            display: 'Chinese (Traditional) - 繁體中文',
            locale: 'zh-TW'
        },
        {
            display: 'Chinese (Traditional) - 繁體中文',
            locale: 'zh-TW'
        },
        {
            display: 'Croatian - Hrvatski',
            locale: 'hr-HR'
        },
        {
            display: 'Czech - Ceština',
            locale: 'cs-CZ'
        },
        {
            display: 'Danish - Dansk',
            locale: 'da-DK'
        },
        {
            display: 'Dutch - Nederlands',
            locale: 'nl-NL'
        },
        {
            display: 'English',
            locale: 'en-US'
        },
        {
            display: 'Estonian - Eesti Keel',
            locale: 'et-EE'
        },
        {
            display: 'Farsi - فارسی',
            locale: 'fa-IR'
        },
        {
            display: 'Filipino - Tagalog',
            locale: 'fil-PH'
        },
        {
            display: 'Finnish - Suomi',
            locale: 'fi-FI'
        },
        {
            display: 'Flemish - Vlaams',
            locale: 'nl-BE'
        },
        {
            display: 'French - Français',
            locale: 'fr-FR'
        },
        {
            display: 'Georgian - ქართული',
            locale: 'ka-GE'
        },
        {
            display: 'German - Deutsch',
            locale: 'de-DE'
        },
        {
            display: 'Greek - Ελληνικά',
            locale: 'el-GR'
        },
        {
            display: 'Hebrew - עברית',
            locale: 'he-IL'
        },
        {
            display: 'Hindi - हिंदी',
            locale: 'hi-IN'
        },
        {
            display: 'Hungarian - Magyar',
            locale: 'hu-HU'
        },
        {
            display: 'Icelandic - Íslenska',
            locale: 'is-IS'
        },
        {
            display: 'Indonesian - Bahasa Indonesia',
            locale: 'id-ID'
        },
        {
            display: 'Italian - Italiano',
            locale: 'it-IT'
        },
        {
            display: 'Japanese - 日本語',
            locale: 'ja-JP'
        },
        {
            display: 'Kazakh - Қазақ тілі',
            locale: 'kk-KZ'
        },
        {
            display: 'Khmer - ភាសាខ្មែរ',
            locale: 'km-KH'
        },
        {
            display: 'Korean - 한국어',
            locale: 'ko-KR'
        },
        {
            display: 'Lao - ພາສາລາວ',
            locale: 'lo-LA'
        },
        {
            display: 'Latvian - Latviešu',
            locale: 'lv-LV'
        },
        {
            display: 'Lithuanian - Lietuvių k',
            locale: 'lt-LT'
        },
        {
            display: 'Macedonian - Македонски',
            locale: 'mk-MK'
        },
        {
            display: 'Malay - Bahasa Melayu',
            locale: 'ms-MY'
        },
        {
            display: 'Malayalam - മലയാളം',
            locale: 'ml-IN'
        },
        {
            display: 'Norwegian (Bokmål) - Norsk',
            locale: 'nb-NO'
        },
        {
            display: 'Polish - Polski',
            locale: 'pl-PL'
        },
        {
            display: 'Portuguese - Português',
            locale: 'pt-PT'
        },
        {
            display: 'Portuguese (Brazil) - Português (Brasil)',
            locale: 'pt-BR'
        },
        {
            display: 'Punjabi - ਪੰਜਾਬੀ',
            locale: 'pa-IN'
        },
        {
            display: 'Romanian - Română',
            locale: 'ro-RO'
        },
        {
            display: 'Russian - Русский',
            locale: 'ru-RU'
        },
        {
            display: 'Serbian (Latin) - Srpski (Latinica)',
            locale: 'sr-Cyrl-CS'
        },
        {
            display: 'Slovak - Slovenčina',
            locale: 'sk-SK'
        },
        {
            display: 'Slovenian - Slovensko',
            locale: 'sl-SI'
        },
        {
            display: 'Spanish (Modern Sort) - Español (Europeo)',
            locale: 'es-ES'
        },
        {
            display: 'Swahili - Swahili',
            locale: 'sw-KE'
        },
        {
            display: 'Swedish - Svenska',
            locale: 'sv-SE'
        },
        {
            display: 'Tamil - தமிழ்',
            locale: 'ta-IN'
        },
        {
            display: 'Thai - ไทย',
            locale: 'th-TH'
        },
        {
            display: 'Turkish - Türkçe',
            locale: 'tr-TR'
        },
        {
            display: 'Ukrainian - Українська',
            locale: 'uk-UA'
        },
        {
            display: 'Urdu - اردو',
            locale: 'ur-PK'
        },
        {
            display: 'Vietnamese - Tiếng Việt',
            locale: 'vi-VN'
        },
        {
            display: 'Xhosa - IsiXhosa',
            locale: 'xh-ZA'
        },
        {
            display: 'Zulu - IsiZulu',
            locale: 'zu-ZA'
        }
    ];

    genderNeutralReportLanguages = [
        {
            display: 'English',
            locale: 'en-US'
        }
    ];
}
